import { render, staticRenderFns } from "./QuoteRepx.vue?vue&type=template&id=b420fa26"
import script from "./QuoteRepx.vue?vue&type=script&lang=js"
export * from "./QuoteRepx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports